import React from 'react';
import cn from 'classnames';

import styles from './StepHeading.module.scss';

interface StepHeadingProps {
  title?: string;
  desc?: string;
  desc2?: string;
  large?: boolean;
}

export const StepHeading: React.FC<StepHeadingProps> = ({
  title,
  desc,
  desc2,
  large,
}) => {
  return (
    <div className={styles.details}>
      {title && (
        <h1 className={cn(styles.title, { [styles.large]: large })}>{title}</h1>
      )}
      {desc && <p className={styles.description}>{desc}</p>}
      {desc2 && <p className={styles.description}>{desc2}</p>}
    </div>
  );
};
